export default __webpack_public_path__ + "static/media/left-rotation-code.0597b445.PNG";